var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHours = function SvgHours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56 28c0 15.464-12.536 28-28 28S0 43.464 0 28 12.536 0 28 0s28 12.536 28 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3DA",
    d: "M28 14.819 11.898 26.455v19.61h32.206v-19.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37517E",
    d: "M14.637 36.478h26.727V9.935H14.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B9FF",
    d: "M19.42 31.88h17.161V14.717h-17.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28 29.066a5.773 5.773 0 0 1-5.766-5.767A5.774 5.774 0 0 1 28 17.531a5.774 5.774 0 0 1 5.767 5.768.574.574 0 0 1-1.147 0 4.626 4.626 0 0 0-4.62-4.62 4.626 4.626 0 0 0-4.62 4.62 4.625 4.625 0 0 0 4.62 4.62 4.6 4.6 0 0 0 2.309-.618.574.574 0 0 1 .576.991 5.75 5.75 0 0 1-2.885.774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28 21.276a2.026 2.026 0 0 0-2.023 2.024c0 1.116.908 2.024 2.024 2.024a2.026 2.026 0 0 0 2.024-2.024A2.026 2.026 0 0 0 28 21.276m0 5.195a3.174 3.174 0 0 1-3.17-3.17A3.174 3.174 0 0 1 28 20.13a3.174 3.174 0 0 1 3.17 3.17 3.174 3.174 0 0 1-3.17 3.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.896 26.47a1.86 1.86 0 0 1-1.32-.548 1.84 1.84 0 0 1-.551-1.323V23.3a.573.573 0 1 1 1.146 0V24.6a.7.7 0 0 0 .211.509.74.74 0 0 0 1.03.002.72.72 0 0 0 .209-.511V23.3a.574.574 0 0 1 1.147 0V24.6a1.865 1.865 0 0 1-1.871 1.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "M44.104 26.455v19.61L28 36.26zM28 36.261l-16.103 9.804v-19.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3DA",
    d: "M44.104 46.065H11.896l16.105-9.804z"
  }))));
};
export default SvgHours;